/**
 * Metal picker (mp-): turns the "10K Yellow Gold / 14K White Gold / Platinum" swatch row
 * into two rows — Gold purity (10K · 14K · 18K) and Metal color (Yellow · Rose · White · Platinum).
 * Platinum is a color circle only; gold purity buttons don't apply to it.
 * The theme's own swatches stay in the page (hidden) and are clicked for the actual change,
 * so variant selection, price and cart behaviour are unchanged.
 */
(function () {
  'use strict';
  if (window.__metalPickerInit) return; // the snippet can render more than once per page
  window.__metalPickerInit = true;

  var COLOURS = {
    yellow: { label: 'Yellow Gold', fill: 'radial-gradient(circle at 35% 30%, #f6e7b8, #d9b56a 60%, #b8913f)' },
    rose: { label: 'Rose Gold', fill: 'radial-gradient(circle at 35% 30%, #f7d9cf, #e0a99a 60%, #c4836f)' },
    white: { label: 'White Gold', fill: 'radial-gradient(circle at 35% 30%, #ffffff, #dcdde0 60%, #b9bbc0)' },
    platinum: { label: 'Platinum', fill: 'radial-gradient(circle at 35% 30%, #ffffff, #d3d6db 60%, #a9adb4)' }
  };

  function parse(value) {
    var v = String(value).toLowerCase();
    var k = /(\d{1,2})\s*-?\s*(k|kt|karat)\b/.exec(v);
    var purity = k ? k[1] + 'K' : /platinum|\bpt\b|950/.test(v) ? 'PT' : null;
    var colour = /yellow/.test(v) ? 'yellow' : /rose|pink/.test(v) ? 'rose' : /white/.test(v) ? 'white' : purity === 'PT' ? 'platinum' : null;
    return purity && colour ? { purity: purity, colour: colour } : null;
  }

  function enhance(fieldset) {
    if (fieldset.dataset.mpDone) return;
    var boxes = Array.prototype.slice.call(fieldset.querySelectorAll('.variant-option__material-box[data-value]'));
    var items = boxes.map(function (box) {
      var p = parse(box.getAttribute('data-value'));
      var input = box.querySelector('input[type="radio"]');
      return p && input ? { box: box, input: input, purity: p.purity, colour: p.colour } : null;
    });
    if (!items.length || items.some(function (i) { return !i; })) { fieldset.classList.add('mp-raw'); return; } // not a purity/colour option: keep the original swatches
    fieldset.dataset.mpDone = '1';
    fieldset.classList.add('mp-on');

    var purities = [], colours = [];
    var COLOUR_ORDER = ['white', 'yellow', 'rose', 'platinum'];
    items.forEach(function (i) {
      if (i.purity !== 'PT' && purities.indexOf(i.purity) < 0) purities.push(i.purity);
      if (colours.indexOf(i.colour) < 0) colours.push(i.colour);
    });
    colours.sort(function (a, b) { return COLOUR_ORDER.indexOf(a) - COLOUR_ORDER.indexOf(b); }); // white, yellow, rose, platinum
    purities.sort(function (a, b) { return (a === 'PT' ? 99 : parseInt(a, 10)) - (b === 'PT' ? 99 : parseInt(b, 10)); });

    var ui = document.createElement('div');
    ui.className = 'mp';
    ui.innerHTML =
      '<div class="mp__group"><p class="mp__title">Gold purity</p><div class="mp__purity" role="radiogroup" aria-label="Gold purity">' +
      purities.map(function (p) { return '<span class="mp__pill-wrap"><button type="button" class="mp__pill" role="radio" data-purity="' + p + '">' + p + '</button><span class="mp__diff" data-diff="' + p + '"></span></span>'; }).join('') +
      '</div></div>' +
      '<div class="mp__group"><p class="mp__title">Metal color</p><div class="mp__colours" role="radiogroup" aria-label="Metal color">' +
      colours.map(function (c) {
        return '<button type="button" class="mp__colour" role="radio" data-colour="' + c + '"><span class="mp__swatch" style="background:' + COLOURS[c].fill + '"></span><span class="mp__name">' + COLOURS[c].label + '</span></button>';
      }).join('') +
      '</div></div>';
    var legend = fieldset.querySelector('legend');
    (legend ? legend.nextSibling : fieldset.firstChild) ? fieldset.insertBefore(ui, legend ? legend.nextSibling : fieldset.firstChild) : fieldset.appendChild(ui);

    // Survives the theme re-rendering the picker after each variant change.
    var state = window.__metalPickerState = window.__metalPickerState || {};
    function current() { return items.filter(function (i) { return i.input.checked; })[0] || items[0]; }
    function find(purity, colour) {
      return items.filter(function (i) { return i.purity === purity && i.colour === colour; })[0] ||
        items.filter(function (i) { return i.purity === purity; })[0] ||
        items.filter(function (i) { return i.colour === colour; })[0];
    }
    function paint() {
      var cur = current();
      var isPt = cur.purity === 'PT';
      ui.querySelectorAll('[data-purity]').forEach(function (b) {
        var on = !isPt && b.dataset.purity === cur.purity;
        b.classList.toggle('is-on', on);
        b.disabled = isPt; // gold purity doesn't apply to platinum
        b.setAttribute('aria-checked', on);
      });
      if (!isPt) state.lastPurity = cur.purity;
      ui.querySelectorAll('[data-colour]').forEach(function (b) {
        var on = b.dataset.colour === cur.colour;
        var exists = b.dataset.colour === 'platinum' || isPt || items.some(function (i) { return i.purity === cur.purity && i.colour === b.dataset.colour; });
        b.classList.toggle('is-on', on);
        b.classList.toggle('is-off', !exists);
        b.setAttribute('aria-checked', on);
      });
    }
    function choose(item) {
      if (!item || item.input.checked) return;
      item.box.click();
      setTimeout(paint, 60);
    }
    ui.addEventListener('click', function (e) {
      var t = e.target instanceof Element ? e.target : null;
      if (!t) return;
      var cur = current();
      var p = t.closest('[data-purity]');
      var c = t.closest('[data-colour]');
      if (p && !p.disabled) choose(find(p.dataset.purity, cur.colour));
      if (c) {
        var col = c.dataset.colour;
        if (col === 'platinum') choose(items.filter(function (i) { return i.colour === 'platinum'; })[0]);
        // Back from platinum to gold: keep the last gold purity used.
        else choose(find(cur.purity === 'PT' ? (state.lastPurity || purities[0]) : cur.purity, col));
      }
    });
    fieldset.addEventListener('change', function () { setTimeout(paint, 30); setTimeout(diffs, 120); });
    paint();
    diffs();

    // Under each purity: how much more it costs than the lowest purity, for the
    // current colour and other options (e.g. "+ Rs. 19,300.00"). Shown once per purity.
    function diffs() {
      productJson().then(function (product) {
        if (!product) return;
        var form = fieldset.closest('form') || document;
        var idInput = form.querySelector('[name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
        var cur = product.variants.filter(function (v) { return String(v.id) === String(idInput && idInput.value); })[0] || product.variants[0];
        var pos = -1;
        product.options.forEach(function (o, i) { if (cur.options[i] === current().input.value) pos = i; });
        if (pos < 0) return;
        var colour = current().colour === 'platinum' ? 'yellow' : current().colour;
        function priceFor(purity) {
          var match = product.variants.filter(function (v) {
            var p = parse(v.options[pos]);
            if (!p || p.purity !== purity || p.colour !== colour) return false;
            return v.options.every(function (val, i) { return i === pos || val === cur.options[i]; });
          })[0];
          return match ? match.price : null;
        }
        var base = priceFor(purities[0]);
        ui.querySelectorAll('[data-diff]').forEach(function (el) {
          var price = priceFor(el.dataset.diff);
          var d = base != null && price != null ? price - base : 0;
          el.textContent = d > 0 ? '+ ' + money(d) : '';
        });
      });
    }
  }

  var productReq = null;
  function productJson() {
    if (productReq) return productReq;
    var m = /\/products\/([^/?#]+)/.exec(location.pathname);
    productReq = m ? fetch('/products/' + m[1] + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }) : Promise.resolve(null);
    return productReq;
  }
  function money(cents) {
    var fmt = window.__mpMoneyFormat || '{{amount}}';
    function group(n, d, t, dec) {
      var parts = (n / 100).toFixed(d).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (parts[1] ? dec + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return group(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return group(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return group(cents, 0, '.', ',');
      return group(cents, 2, ',', '.');
    }).replace(/<[^>]+>/g, '');
  }

  function run() {
    document.querySelectorAll('fieldset.variant-option--material-swatches').forEach(enhance);
  }
  run();
  // The theme re-renders the variant picker after each change: enhance the new markup too.
  new MutationObserver(function () { run(); }).observe(document.body, { childList: true, subtree: true });
})();
